import { FC } from 'react';

import { Text, VSpacing } from '@hh.ru/magritte-ui';

interface SectionHeaderProps {
    title: string;
    subtitle: string;
}

export const SectionHeader: FC<SectionHeaderProps> = ({ title, subtitle }) => {
    return (
        <div>
            <Text typography="title-5-semibold">{title}</Text>
            <VSpacing default={8} />
            <Text typography="label-3-regular" style="secondary">
                {subtitle}
            </Text>
        </div>
    );
};
